import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getLoginRedirectObject, getTemporaryTwoFaUser, getTemporaryTwoFaUserToken } from '../store';
import { useNavigate } from '../../../../../infra/routing';
import { useFeatureFlags } from '../../../../../infra/feature-flags';
import { confirmUserLogin } from '../../../login/actions/confirm-user-login';
import { useToggle } from '../../../../../infra/small-tools/use-toggle';
export var useTempUserGuard = function (tempUserFlagsContextSwitcher) {
    var isTempUserLdContextLoaded = tempUserFlagsContextSwitcher.isTempUserLdContextLoaded, switchTempUserLdContext = tempUserFlagsContextSwitcher.switchTempUserLdContext;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var flags = useFeatureFlags();
    var isTwoFaLdOn = flags['2FaEnable'] && flags['2FaPhaseOne'];
    var tempUser = useSelector(getTemporaryTwoFaUser);
    var tempToken = useSelector(getTemporaryTwoFaUserToken);
    var redirectObject = useSelector(getLoginRedirectObject);
    var shouldPerformSecondFactorCheck = useToggle(false);
    useEffect(function () {
        if (!tempUser || !tempUser.optIn2FA || !tempUser.multiFactorConfigs || !tempUser.multiFactorConfigs.length) {
            // if we're here by mistake, redirect to login
            navigate('/login');
        }
    }, []);
    useEffect(function () {
        // load LD flags for this specific half-logged-in user
        switchTempUserLdContext(tempUser);
    }, []);
    useEffect(function () {
        if (tempUser && isTempUserLdContextLoaded && !isTwoFaLdOn) {
            // if 2FA LD flag is off, just log in the user without second factor check
            confirmUserLogin({
                user: tempUser,
                token: tempToken,
                redirectObject: redirectObject,
                dispatch: dispatch,
                navigate: navigate,
            });
        }
    }, [tempUser, isTwoFaLdOn, isTempUserLdContextLoaded]);
    useEffect(function () {
        var _a;
        var isLdFlagOn = isTempUserLdContextLoaded && isTwoFaLdOn;
        var isUserSetUpForTwoFa = tempUser && tempUser.optIn2FA && ((_a = tempUser.multiFactorConfigs) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (isLdFlagOn && isUserSetUpForTwoFa) {
            shouldPerformSecondFactorCheck.setOn();
        }
    }, [isTempUserLdContextLoaded, isTwoFaLdOn, shouldPerformSecondFactorCheck, tempUser]);
    return shouldPerformSecondFactorCheck.isOn;
};
